var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('navbar'),(!!_vm.version)?_c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"main-wrapper__menu"},[_c('new-menu')],1),_c('app-main',{staticClass:"main-wrapper__pages"})],1):_c('app-main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }